var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraduationCap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9986 11.7128C33.9986 10.1035 33.1047 8.62874 31.5492 7.73624L20.5615 2.71841C18.3982 1.47316 15.6003 1.47457 13.4923 2.68866L2.448 7.73766C2.42817 7.74757 2.40833 7.75749 2.38992 7.76741C0.8925 8.62874 0 10.1035 0 11.7128C0 13.3222 0.893917 14.7969 2.44942 15.6894L5.66667 17.1585V25.9177C5.66667 28.6519 7.35958 31.0617 9.87983 31.9145C11.9637 32.62 14.3593 32.977 17 32.977C19.6407 32.977 22.0377 32.62 24.1202 31.9145C26.639 31.0602 28.3333 28.6505 28.3333 25.9177V17.1571L31.6087 15.6597C31.9699 15.4514 32.2957 15.2049 32.5833 14.9329V29.4367C32.5833 29.8277 32.9007 30.1451 33.2917 30.1451C33.6827 30.1451 34 29.8277 34 29.4367V11.7284C34 11.7284 34 11.7256 34 11.7242C34 11.7213 34 11.7171 34 11.7142L33.9986 11.7128ZM26.9153 25.9163C26.9153 28.0427 25.6091 29.9127 23.6654 30.5715C21.7288 31.2274 19.4848 31.5589 16.9986 31.5589C14.5123 31.5589 12.2683 31.2274 10.3317 30.5715C8.38808 29.9127 7.08192 28.0427 7.08192 25.9163V17.8045L13.4342 20.7044C14.5237 21.3306 15.7717 21.6422 17.0127 21.6422C18.2382 21.6422 19.4565 21.3377 20.5034 20.7342L26.9138 17.8031L26.9153 25.9163ZM30.9598 14.3988L19.856 19.4762C18.1177 20.4763 15.8737 20.4763 14.0817 19.4464L3.094 14.43C2.02725 13.8152 1.41383 12.8249 1.41383 11.7128C1.41383 10.6107 2.01592 9.62607 3.06708 9.01124L14.1383 3.94807C15.8766 2.94649 18.1206 2.94932 19.9127 3.97782L30.9003 8.99566C31.9671 9.61049 32.5805 10.6007 32.5805 11.7128C32.5805 12.8249 31.9685 13.8152 30.9598 14.3988Z",
    fill: "url(#paint0_linear_4488_5149)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4488_5149",
    x1: -4.95833,
    y1: -5.36777,
    x2: 26.9676,
    y2: 35.6913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7410FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduationCap);
export default __webpack_public_path__ + "static/media/graduation-cap.30927e8a2a2ca232f7aa28e76ce619fa.svg";
export { ForwardRef as ReactComponent };